import LineRoomUpgradeIcon from 'components/Luxkit/Icons/line/LineRoomUpgradeIcon'
import ModalContext from 'contexts/ModalContext'
import { useAppSelector } from 'hooks/reduxHooks'
import getLoyaltyDisplayTier from 'loyalty/selectors/getLoyaltyDisplayTier'
import React, { useCallback, useContext } from 'react'
import LoyaltyRoomUpgradeBenefitModal from './LoyaltyRoomUpgradeBenefitModal'
import LoyaltyTierBenefitLabel from './LoyaltyTierBenefitLabel'
import withMountGuard from 'hocs/withMountGuard'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'

function LoyaltyRoomUpgradeBenefitLabel() {
  const tier = useAppSelector(getLoyaltyDisplayTier)
  const showModal = useContext(ModalContext)

  const showRoomUpgradesModal = useCallback(() => {
    showModal(<LoyaltyRoomUpgradeBenefitModal />)
  }, [showModal])

  return <LoyaltyTierBenefitLabel
    tier={tier}
    icon={<LineRoomUpgradeIcon />}
    onClick={showRoomUpgradesModal}
  >
    Free room upgrade
  </LoyaltyTierBenefitLabel>
}

export default withMountGuard(() => {
  return useAppSelector(getIsLoyaltyEnabled)
})(LoyaltyRoomUpgradeBenefitLabel)
